import axios from "axios";

/**
 * 로그아웃 처리 공통 함수
 * @param {Function} navigate - useNavigate 훅
 * @param {Function} [setId] - 사용자 ID 상태 setter
 * @param {Function} [setProfileBox] - 프로필 박스 표시 setter
 */
export const handleLogout = (navigate, setId, setName, setBirthDate) => {
    axios.post(`${process.env.REACT_APP_SPRING_API_URL}/api/logout`, {}, { withCredentials: true })
        .finally(() => {
            // 토큰 및 axios 헤더 초기화
            localStorage.removeItem("jwtToken");
            delete axios.defaults.headers.common.Authorization;

            // 선택적으로 상태 초기화
            if (setId) setId(null);
            if (setName) setName(null);
            if (setBirthDate) setBirthDate(null);

            // 홈으로 이동
            navigate("/");
            window.location.reload();
        });
};